module.exports = __webpack_public_path__ + "img/C4A591_635448_F2D9D5_856D5B-256px.4d857c70.png";